import * as Api from "@api";
import clsx from "clsx";
import React from "react";
import { LayoutMargins, MediaSpecific, marginsClassMSL } from "../Layout";
import { PageContent } from "../Page";
import { Typography } from '@/components';
import css from "./side-by-side-text.module.scss";

type SideBySideTextPageKeys = readonly [string, string];

export interface SideBySideTextLayout extends LayoutMargins { }

export interface SideBySideTextProps<Keys extends SideBySideTextPageKeys> extends React.ComponentProps<"div">
{
    items?: { [Key in Keys[number]]?: Partial<React.ComponentProps<typeof PageContent>> };
    keys: SideBySideTextPageKeys;
    layout?: MediaSpecific<SideBySideTextLayout>;
    nodes?: { [Key in Keys[number]]?: React.ReactNode };
    pageContent: Api.Content<Keys[number]>;
}

export const SideBySideText = <Keys extends SideBySideTextPageKeys>({ className, items, keys, layout, nodes, pageContent, ...props }: SideBySideTextProps<Keys>): React.ReactComponentElement<"div", SideBySideTextProps<Keys>> =>
{
    const classes = clsx(
        css["panel"],
        marginsClassMSL(layout),
        className
    );

    const getItemContent = (index: number, typography: Typography): React.ReactNode => 
    {
        const key = keys[index] as Keys[number];

        const node = nodes?.[key];
        if (node !== undefined)
        {
            return node;
        }

        const props = items?.[key];
        return <PageContent {...Api.ContentService.getItem(pageContent, key)} {...props} typography={props?.typography ?? typography} />;
    }

    return (
        <div {...props} className={classes}>
            <div>
                {getItemContent(0, Typography.H2)}
            </div>
            <div>
                {getItemContent(1, Typography.P1)}
            </div>
        </div>
    );
}